import { Component, Input } from '@angular/core';
import { ExternalUrls } from '../../externalUrls';

@Component({
  selector: 'app-plan-upgrade-box',
  templateUrl: './plan-upgrade-box.component.html',
  styleUrls: ['./plan-upgrade-box.component.scss'],
  standalone: false
})
export class PlanUpgradeBoxComponent {
  @Input() title = "You'll need to upgrade your Lineup plan to get access to this feature.";
  @Input() body = '';
  readonly externalUrls = ExternalUrls;
}
